import { FontSize, FontWeights } from 'pkg/config/fonts';
import spacing from 'pkg/config/spacing';

import { cssClasses } from 'pkg/css/utils';

import MaterialSymbol from 'components/material-symbols';

import Row from 'components/layout/row';
import type { MaterialSymbolVariant } from 'components/material-symbols/symbols';
import { TextWrapper } from 'components/text/text_wrapper';

import * as css from './styles.css';

interface CardCellProps {
	order?: 'up' | 'down'; // Determines the order of the rows
	size?: 'default' | 'large'; // Controls the size of the value and valueIcon
	valueIcon?: MaterialSymbolVariant;
	value?: string;
	descriptionIcon?: MaterialSymbolVariant;
	description?: string;
	capatalizeDescription?: boolean; // Capitalizes the description text
	capatalizeValue?: boolean; // Capitalizes the value text
}

export function CardCell({
	value,
	valueIcon,
	order = 'down',
	size = 'default',
	descriptionIcon,
	description,
	capatalizeValue = false,
	capatalizeDescription = false,
}: CardCellProps) {
	return (
		<div className={cssClasses(css.cardCell, order === 'up' ? css.up : '')}>
			<Row
				columns="auto 1fr"
				spacing={spacing._2}
				align="center"
				className={
					size === 'default' ? css.defaultValueSize : css.largeValueSize
				}>
				{valueIcon && (
					<MaterialSymbol variant={valueIcon} className={css.valueIcon} />
				)}
				{value && (
					<TextWrapper
						className={css.value}
						text={value}
						textTransform={capatalizeValue ? 'capitalize' : 'none'}
					/>
				)}
			</Row>
			<Row columns="auto 1fr" align="center" spacing={spacing._2}>
				{descriptionIcon && (
					<MaterialSymbol
						variant={descriptionIcon}
						className={css.descriptionIcon}
					/>
				)}
				{description && (
					<TextWrapper
						className={css.description}
						text={description}
						fontSize={FontSize.sm}
						fontWeight={FontWeights.Normal}
						textTransform={capatalizeDescription ? 'capitalize' : 'none'}
					/>
				)}
			</Row>
		</div>
	);
}
